const normalizeText = (value) => String(value || "").trim();

const normalizeForKeywordCompare = (value) =>
  normalizeText(value)
    .normalize("NFKD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase()
    .replace(/&/g, " and ")
    .replace(/['’]/g, "")
    .replace(/[^a-z0-9]+/g, " ")
    .replace(/\s+/g, " ")
    .trim();

const isConsonantBeforeY = (word) =>
  word.length > 1 && /[bcdfghjklmnpqrstvwxyz]y$/.test(word);

const getWordForms = (word) => {
  const normalizedWord = normalizeForKeywordCompare(word);
  if (!normalizedWord || normalizedWord.includes(" ")) {
    return [];
  }

  const forms = new Set([normalizedWord]);

  if (normalizedWord.endsWith("ies") && normalizedWord.length > 3) {
    forms.add(`${normalizedWord.slice(0, -3)}y`);
  }

  if (/(ches|shes|xes|zes|sses)$/.test(normalizedWord)) {
    forms.add(normalizedWord.slice(0, -2));
  }

  if (
    normalizedWord.endsWith("s") &&
    !/(ss|is|us)$/.test(normalizedWord) &&
    normalizedWord.length > 1
  ) {
    forms.add(normalizedWord.slice(0, -1));
  }

  if (isConsonantBeforeY(normalizedWord)) {
    forms.add(`${normalizedWord.slice(0, -1)}ies`);
  } else if (/(s|x|z|ch|sh)$/.test(normalizedWord)) {
    forms.add(`${normalizedWord}es`);
  } else if (!normalizedWord.endsWith("s")) {
    forms.add(`${normalizedWord}s`);
  }

  return Array.from(forms).filter(Boolean);
};

export const getForbiddenKeywordDefinitionTerms = (keyword) => {
  const normalizedKeyword = normalizeForKeywordCompare(keyword);
  if (!normalizedKeyword) {
    return [];
  }

  const words = normalizedKeyword.split(" ").filter(Boolean);
  if (!words.length) {
    return [];
  }

  const terms = new Set([normalizedKeyword]);

  if (words.length === 1) {
    getWordForms(words[0]).forEach((form) => terms.add(form));
  } else {
    getWordForms(words[words.length - 1]).forEach((lastWordForm) => {
      terms.add([...words.slice(0, -1), lastWordForm].join(" "));
    });
  }

  return Array.from(terms).sort((left, right) => right.length - left.length);
};

export const getKeywordDefinitionExposureMatches = (keyword, definition) => {
  const normalizedDefinition = normalizeForKeywordCompare(definition);
  if (!normalizedDefinition) {
    return [];
  }

  const searchableDefinition = ` ${normalizedDefinition} `;

  return getForbiddenKeywordDefinitionTerms(keyword).filter((term) =>
    searchableDefinition.includes(` ${term} `),
  );
};

export const doesDefinitionRevealKeyword = (keyword, definition) =>
  getKeywordDefinitionExposureMatches(keyword, definition).length > 0;

export const assertDefinitionDoesNotRevealKeyword = (
  keyword,
  definition,
  {
    source = "Definition",
    message = `${source} for "${normalizeText(
      keyword,
    )}" includes the keyword or a close variant. Regenerate or edit it before saving.`,
  } = {},
) => {
  if (doesDefinitionRevealKeyword(keyword, definition)) {
    throw new Error(message);
  }
};

